import type {ExtractPropsWithoutRef} from '@/types';

import styled from '@emotion/styled';
import {IconList} from '@travel-frontend/icons';
import {memo} from 'react';
import {useTranslation} from 'react-i18next';

import {Button} from '@/components/BackToHotelsButton/components/Button';

const Component = styled(
  ({style, ...restProps}: ExtractPropsWithoutRef<typeof Button>) => {
    const {t} = useTranslation('hotels');

    return (
      <Button
        {...restProps}
        variant="neutral"
        icon={<IconList />}
        style={{...style, pointerEvents: 'all'}}
      >
        {t('mapView.backToHotelsButton.label')}
      </Button>
    );
  }
)``;

export const BackToHotelsButton = memo(Component);
